// IMPORTANT Autogenerated file
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import {
  CountWidgetDto,
  ScheduledMaintenanceReminderDto,
} from '@ellf/common-dto';
import { ApiClientConfig } from '../api-client-config';
import { BaseCRUDApiClient } from './baseCRUD.api-client';

@Injectable()
export class ScheduledMaintenanceReminderApiClient extends BaseCRUDApiClient<ScheduledMaintenanceReminderDto> {
  baseUrl = this.config.apiEndpoint + '/scheduled-maintenance-reminder';

  constructor(http: HttpClient, config: ApiClientConfig) {
    super(http, config);
  }
  getCountInPeriod(
    fromDate: string | undefined,
    toDate: string | undefined,
    filters: any,
  ) {
    return this.http.post<CountWidgetDto>(
      `${this.baseUrl}/get-count-in-period`,
      {
        fromDate,
        toDate,
        ...filters,
      },
    );
  }
}
